<template>
  <div class="container-brains-checkbox" :class="['checkbox-' + width]">
    <div class="checkbox" :class="['checkbox-direction-' + direction, 'checkbox-' + width, { 'checkbox--selected': checkModelInclude() }, { 'checkbox--centered' : label === '' } ]">
      <label class="checkbox-label" :class="{ 'checkbox-label--disabled' : disabled }" @click="manageClick">{{ label }}</label>
      <input v-model="vModel" type="checkbox" :value="inputValue" hidden>
      <span :class="[{ 'fake-checkbox-btn--selected': checkModelInclude() }, { 'fake-checkbox-btn--disabled' : disabled }]" class="fake-checkbox-btn" @click="manageClick">
        <font-awesome-icon icon="check" />
      </span>
    </div>
    <div v-if="disabled" class="layer-inactive-input" />
  </div>
</template>
<script>
export default {
  name: 'BrainsCheckbox',
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    inputValue: {
      default: null
    },
    direction: {
      type: String,
      default: 'right'
    },
    width: {
      type: String,
      default: 'full-width'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      vModel: this.value
    }
  },
  computed: {
    brainsCheckboxId() {
      return 'brains-checkbox-' + this.randomNum + '-' + this.inputValue
    }
  },
  watch: {
    value() {
      this.vModel = this.value
    },
    vModel(newOne, oldOne) {
      this.handleInput()
    }
  },
  created() {
    this.generateRandomNum()
  },
  methods: {
    checkModelInclude() {
      if (typeof this.vModel === 'boolean') {
        return this.vModel
      } else {
        return this.vModel.includes(this.inputValue)
      }
    },
    manageClick() {
      if (typeof this.vModel === 'boolean') {
        this.vModel = !this.vModel
      } else {
        if (!Array.isArray(this.vModel)) {
          this.vModel = []
        }

        if (this.vModel.includes(this.inputValue)) {
          this.vModel = this.vModel.filter(item => { return item !== this.inputValue })
        } else {
          this.vModel.push(this.inputValue)
        }
      }
    },
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    },
    handleInput(e) {
      this.$emit('input', this.vModel)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.checkbox-full-width {
  width: 100%;
}

.checkbox-no-full-width {
  display: inline-flex;

  .checkbox label {
    margin-right: 10px;
  }
}

.layer-inactive-input {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.container-brains-checkbox {
  position: relative;

  .checkbox {
    display: flex;
    justify-content: space-between;
    align-items: center;

    label {
      cursor: pointer;
      font-size: 14px;

      &:hover ~ .fake-checkbox-btn {
        border-color: $primary-brains;
      }
    }

    &--selected {
      color: $primary-brains;
      font-family: 'Montserrat-SemiBold',sans-serif;
    }

    &--centered {
      justify-content: center;
    }

    .fake-checkbox-btn {
      border: 1px solid #333333;
      width: 16px;
      height: 16px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        font-size: 14px;
        color: white;
        visibility: hidden;
      }

      &--selected {
        background-color: $primary-brains;

        svg {
          visibility: visible;
        }
      }

      &:hover {
        border-color: $primary-brains;
      }
    }
  }

  .checkbox-direction- {
    &left {
      flex-direction: row-reverse;
      gap: 10px;
    }
  }
}

.checkbox-label--disabled {
  color: rgb(194, 194, 194);
}

.fake-checkbox-btn--disabled {
  border-color: rgb(194, 194, 194) !important;
}
</style>
